import React from 'react';
import DeviceValidationStatus from 'components/DeviceValidationStatus';
import { connect } from 'react-redux';

import LoginPage from 'components/LoginPage';
import UserLoginImageContainer from 'components/UserLoginImageContainer';
import i18n from 'i18n';
import { Grid } from '@material-ui/core';

interface Props {
  config: any;
}

const DeviceValidationPage: React.FC<Props> = ({ config }) => {
  const language = i18n.language || 'pt-BR';

  const descriptionText =
    {
      es: config?.descriptionLoginTextEs,
      'en-US': config?.descriptionLoginTextEn,
      'pt-BR': config?.descriptionLoginTextPtBr,
    }[language] || config?.descriptionLoginTextPtBr;

  const headerText =
    {
      es: config?.headerLoginTextEs,
      'en-US': config?.headerLoginTextEn,
      'pt-BR': config?.headerLoginTextPtBr,
    }[language] || config?.headerLoginTextPtBr;
  return (
    <LoginPage
      imageWrapper={
        <UserLoginImageContainer
          bgImage={
            config?.defaultBannerOption !== 0 &&
            config?.defaultBannerOption !== null
              ? `/images/defaultImage${config?.defaultBannerOption}.png`
              : config?.imageUrl
          }
          description={descriptionText}
          header={headerText}
          imageColor={config?.imageLoginBackgroundColor}
        />
      }
      logoUrl={config?.logoUrl}
      logoBackgroundColor={config?.logoBackgroundColor}
    >
      <Grid container justifyContent="center">
        <DeviceValidationStatus />
      </Grid>
    </LoginPage>
  );
};

const mapStateToProps = ({ auth, config }) => ({
  token: auth.isAuthenticate?.access_token,
  config,
  shouldUpdatePlugin: auth.shouldUpdatePlugin,
});

export default connect(mapStateToProps)(DeviceValidationPage);
